import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeSignReceiptUpdate } from './serialize';

/** PATCH `/aftersales/sign-receipt/{id}`（僅 DRAFT）。 */
export async function updateSignReceipt(id, payload) {
  const { data: raw } = await request.patch(
    `/aftersales/sign-receipt/${id}`,
    serializeSignReceiptUpdate(payload),
  );
  return parseVer4DetailResponse(raw);
}
